/* HOLO VAULT v3 — rails, tabs, hero holo card, notify dialog, product page perks. No dependencies. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var ready = function (fn) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); };
  var onAll = function (fn) { ready(fn); document.addEventListener('shopify:section:load', fn); };

  /* ---------- Rails: arrows scroll the track by most of its width ---------- */
  function initRails() {
    document.querySelectorAll('[data-hx-rail]').forEach(function (rail) {
      if (rail.dataset.hxBound) return; rail.dataset.hxBound = '1';
      var track = rail.querySelector('[data-hx-track]'); if (!track) return;
      var prev = rail.querySelector('[data-hx-prev]'), next = rail.querySelector('[data-hx-next]');
      var update = function () {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
        var arrows = rail.querySelector('.hx-arrows'); if (arrows) arrows.hidden = max <= 0;
      };
      var go = function (dir) { track.scrollBy({ left: dir * Math.max(240, track.clientWidth * 0.85), behavior: reduce ? 'auto' : 'smooth' }); };
      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }
  onAll(initRails);

  /* ---------- Homepage release banner: tabs switch slides; autoplay until someone picks a tab ---------- */
  function initBanner() {
    document.querySelectorAll('[data-hx-banner]').forEach(function (bn) {
      if (bn.dataset.hxBound) return; bn.dataset.hxBound = '1';
      var slides = [].slice.call(bn.querySelectorAll('[data-hx-bn-slide]'));
      var tabs = [].slice.call(bn.querySelectorAll('[data-hx-bn-tab]'));
      if (slides.length < 2 || tabs.length !== slides.length) return;
      var cur = 0, timer = 0, paused = false, stopped = reduce || bn.dataset.autoplay !== 'true';
      var show = function (i, focus) {
        cur = (i + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.hidden = k !== cur; });
        tabs.forEach(function (t, k) { var on = k === cur; t.setAttribute('aria-selected', on ? 'true' : 'false'); t.tabIndex = on ? 0 : -1; });
        var t = tabs[cur];
        if (t.parentNode.scrollWidth > t.parentNode.clientWidth) t.parentNode.scrollTo({ left: Math.max(0, t.offsetLeft - 16), behavior: reduce ? 'auto' : 'smooth' });
        if (focus) t.focus();
        restart();
      };
      var restart = function () {
        clearTimeout(timer);
        bn.classList.remove('is-playing');
        if (stopped || paused) return;
        void bn.offsetWidth;
        bn.classList.add('is-playing');
        timer = setTimeout(function () { show(cur + 1); }, 7000);
      };
      tabs.forEach(function (t, k) {
        t.addEventListener('click', function () { stopped = true; show(k); });
        t.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          e.preventDefault(); stopped = true; show(cur + (e.key === 'ArrowRight' ? 1 : -1), true);
        });
      });
      bn.addEventListener('mouseenter', function () { paused = true; restart(); });
      bn.addEventListener('mouseleave', function () { paused = false; restart(); });
      bn.addEventListener('focusin', function () { paused = true; restart(); });
      bn.addEventListener('focusout', function (e) { if (!bn.contains(e.relatedTarget)) { paused = false; restart(); } });
      document.addEventListener('visibilitychange', function () { paused = document.hidden; restart(); });
      if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { var vis = en[0].isIntersecting; if (vis === !bn.dataset.hxOff) return; bn.dataset.hxOff = vis ? '' : '1'; paused = !vis; restart(); }).observe(bn);
      restart();
    });
  }
  onAll(initBanner);

  /* ---------- Delivery timeline: real dates from UK working days ---------- */
  // England & Wales bank holidays (we ship from Manchester)
  var HX_HOLIDAYS = ['2026-12-25','2026-12-28','2027-01-01','2027-03-26','2027-03-29','2027-05-03','2027-05-31','2027-08-30','2027-12-27','2027-12-28','2028-01-03','2028-04-14','2028-04-17'];
  function ukToday() {
    try {
      var p = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
      var g = function (t) { return +p.filter(function (x) { return x.type === t; })[0].value; };
      return new Date(Date.UTC(g('year'), g('month') - 1, g('day')));
    } catch (_) { var n = new Date(); return new Date(Date.UTC(n.getFullYear(), n.getMonth(), n.getDate())); }
  }
  var iso = function (d) { return d.toISOString().slice(0, 10); };
  var isWork = function (d) { var w = d.getUTCDay(); return w !== 0 && w !== 6 && HX_HOLIDAYS.indexOf(iso(d)) < 0; };
  function addWork(d, n) { var x = new Date(d.getTime()); while (n > 0) { x.setUTCDate(x.getUTCDate() + 1); if (isWork(x)) n--; } return x; }
  var MON = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  var DAY = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
  var fmt = function (d) { return d.getUTCDate() + ' ' + MON[d.getUTCMonth()]; };
  var range = function (a, b) {
    if (iso(a) === iso(b)) return DAY[a.getUTCDay()] + ' ' + fmt(a);
    return a.getUTCMonth() === b.getUTCMonth() ? a.getUTCDate() + '–' + fmt(b) : fmt(a) + ' – ' + fmt(b);
  };
  function initEta() {
    var today = ukToday();
    document.querySelectorAll('[data-hx-eta]').forEach(function (el) {
      var d = (el.dataset.d || '1,2').split(',').map(Number), t = (el.dataset.t || '3,5').split(',').map(Number);
      var set = function (k, v) { var b = el.querySelector('[data-eta="' + k + '"]'); if (b) b.textContent = v; };
      set('order', fmt(today));
      if (el.dataset.mode === 'pre') {
        if (el.dataset.release) {
          var r = new Date(el.dataset.release + 'T00:00:00Z');
          if (r > today) set('after', 'From ' + fmt(addWork(r, 1)));
        }
        return;
      }
      var s1 = addWork(today, d[0]), s2 = addWork(today, d[1]);
      set('ship', range(s1, s2));
      set('deliver', range(addWork(s1, t[0]), addWork(s2, t[1])));
    });
  }
  onAll(initEta);

  /* ---------- Product page: quantity offers set the quantity box ---------- */
  function initQo() {
    var box = document.querySelector('[data-hx-qo]'); if (!box || box.dataset.hxBound) return; box.dataset.hxBound = '1';
    var opts = [].slice.call(box.querySelectorAll('[data-q]'));
    var qtyInput = function () { return document.querySelector('.product__info-container [data-hx-qty]') || document.querySelector('.product__info-container input[name="quantity"]'); };
    var fmt = function (p) { return new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(p / 100); };
    var mark = function (q) { var k = q >= 3 ? 3 : Math.max(1, q); opts.forEach(function (o) { o.setAttribute('aria-checked', Number(o.dataset.q) === k ? 'true' : 'false'); }); };
    var paint = function () { var price = Number(box.dataset.price) || 0; opts.forEach(function (o) { var q = Number(o.dataset.q), pct = Number(o.dataset.pct) || 0; var t = o.querySelector('[data-qo-total]'); if (t) t.textContent = fmt((price - Math.floor(price * pct / 100)) * q); }); };
    opts.forEach(function (o) {
      o.addEventListener('click', function () {
        var q = Number(o.dataset.q), inp = qtyInput();
        if (inp) { inp.value = q; inp.dispatchEvent(new Event('change', { bubbles: true })); inp.dispatchEvent(new Event('input', { bubbles: true })); }
        mark(q);
      });
    });
    document.addEventListener('change', function (e) {
      if (e.target.matches && e.target.matches('input[name="quantity"]')) mark(Number(e.target.value) || 1);
      if (e.target.closest && e.target.closest('variant-selects, variant-radios, .product-form__input')) setTimeout(function () {
        var price = document.querySelector('.product__info-container .price-item--last, .product__info-container .price-item--regular');
        if (price) { var v = parseFloat(price.textContent.replace(/[^0-9.]/g, '')); if (v) { box.dataset.price = Math.round(v * 100); paint(); } }
      }, 350);
    });
    document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.quantity__button')) setTimeout(function () { var i = qtyInput(); if (i) mark(Number(i.value) || 1); }, 50); });
    var i0 = qtyInput(); if (i0) mark(Number(i0.value) || 1);
  }
  onAll(initQo);

  /* ---------- Tabs ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-hx-tab]'); if (!t) return;
    var root = t.closest('[data-hx-tabs]'); if (!root) return;
    root.querySelectorAll('[data-hx-tab]').forEach(function (b) {
      var on = b === t; b.setAttribute('aria-selected', on ? 'true' : 'false'); b.tabIndex = on ? 0 : -1;
      var p = document.getElementById(b.getAttribute('aria-controls')); if (p) p.hidden = !on;
    });
  });
  document.addEventListener('keydown', function (e) {
    var t = e.target.closest && e.target.closest('[data-hx-tab]'); if (!t || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
    var all = [].slice.call(t.closest('[role="tablist"]').querySelectorAll('[data-hx-tab]'));
    var n = all[(all.indexOf(t) + (e.key === 'ArrowRight' ? 1 : all.length - 1)) % all.length];
    e.preventDefault(); n.focus(); n.click();
  });

  /* ---------- Hero holo card: foil follows the pointer, thumbnails switch the product ---------- */
  function initHolo() {
    document.querySelectorAll('[data-hx-hero]').forEach(function (hero) {
      if (hero.dataset.hxBound) return; hero.dataset.hxBound = '1';
      var holo = hero.querySelector('[data-hx-holo]'), card = hero.querySelector('[data-hx-holo-card]');
      var slides = [].slice.call(hero.querySelectorAll('[data-hx-slide]'));
      var thumbs = [].slice.call(hero.querySelectorAll('[data-hx-go]'));
      var cur = 0, timer = 0, hovering = false;
      var set = function (x, y) {
        card.style.setProperty('--mx', (x * 100).toFixed(1) + '%');
        card.style.setProperty('--my', (y * 100).toFixed(1) + '%');
        card.style.setProperty('--rx', ((0.5 - y) * 14).toFixed(2) + 'deg');
        card.style.setProperty('--ry', ((x - 0.5) * 18).toFixed(2) + 'deg');
        card.style.setProperty('--hyp', Math.min(1, Math.hypot(x - 0.5, y - 0.5) * 2).toFixed(3));
      };
      set(0.62, 0.3);
      if (fine && !reduce && holo) {
        holo.addEventListener('pointermove', function (e) {
          var r = card.getBoundingClientRect();
          set(Math.max(0, Math.min(1, (e.clientX - r.left) / r.width)), Math.max(0, Math.min(1, (e.clientY - r.top) / r.height)));
          card.classList.add('is-live');
        });
        holo.addEventListener('pointerenter', function () { hovering = true; });
        holo.addEventListener('pointerleave', function () { hovering = false; card.classList.remove('is-live'); set(0.62, 0.3); });
      }
      var show = function (i) {
        if (!slides.length) return;
        cur = (i + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.hidden = k !== cur; });
        thumbs.forEach(function (t, k) { t.setAttribute('aria-selected', k === cur ? 'true' : 'false'); });
        if (!reduce) { card.classList.remove('is-flip'); void card.offsetWidth; card.classList.add('is-flip'); }
      };
      thumbs.forEach(function (t) { t.addEventListener('click', function () { show(Number(t.dataset.hxGo)); restart(); }); });
      var restart = function () {
        clearInterval(timer);
        if (reduce || slides.length < 2) return;
        timer = setInterval(function () { if (!hovering && !document.hidden && inView) show(cur + 1); }, 6000);
      };
      var inView = true;
      if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { inView = en[0].isIntersecting; }).observe(hero);
      restart();
    });
  }
  onAll(initHolo);

  /* ---------- Notify me dialog ---------- */
  function notifyDialog() { return document.getElementById('hx-notify'); }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-hx-notify]'); var d = notifyDialog();
    if (b && d) {
      e.preventDefault();
      var name = d.querySelector('[data-hx-notify-name]'), field = d.querySelector('[data-hx-notify-field]');
      if (name) name.textContent = b.dataset.hxNotify;
      if (field) field.value = b.dataset.hxNotify + ' — ' + (b.dataset.hxUrl || location.href);
      d.showModal();
      var input = d.querySelector('input[type="email"]'); if (input) input.focus();
      return;
    }
    if (e.target.closest('[data-hx-notify-close]')) { var dd = notifyDialog(); if (dd) dd.close(); }
  });
  ready(function () {
    var d = notifyDialog(); if (!d) return;
    d.addEventListener('click', function (e) { if (e.target === d) d.close(); });
    if (/HxNotifyForm/.test(location.hash) && d.querySelector('.hx-notify__h')) { try { d.showModal(); } catch (_) {} }
  });

  /* ---------- Product page: what the bag + this product unlocks ---------- */
  function initPerks() {
    var box = document.querySelector('[data-hx-perks]'); if (!box || box.dataset.hxBound) return; box.dataset.hxBound = '1';
    var msg = box.querySelector('[data-hx-perks-msg]');
    var paint = function () {
      var R = window.HXPerks; if (!R || !R.active()) return;
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
        var lines = R.linesOf(cart);
        var title = box.dataset.title, inBag = lines.some(function (l) { return l.title === title; });
        if (!inBag) lines.push({ title: title, type: box.dataset.type, vendor: box.dataset.vendor, qty: 1, paid: Number(box.dataset.price) });
        var p = R.plan(lines);
        box.querySelectorAll('[data-perk]').forEach(function (li) { li.classList.toggle('is-on', p.owned(li.dataset.perk)); });
        var lead = inBag ? 'With your bag: ' : (lines.length > 1 ? 'Your bag plus this: ' : 'This item on its own: ');
        var got = R.label(p.g);
        var html = got ? lead + '<b>' + got.charAt(0).toLowerCase() + got.slice(1) + '</b>.' : '';
        if (p.next) html += (html ? ' ' : '') + 'Add <b>' + R.money(p.next.need) + '</b> more to unlock ' + p.next.what + '.';
        if (msg && html) msg.innerHTML = html;
      }).catch(function () {});
    };
    paint();
    document.addEventListener('hx:cart', paint);
    document.addEventListener('change', function (e) { if (e.target.closest('variant-selects, variant-radios, .product-form__input')) setTimeout(function () {
      var form = document.querySelector('form[action*="/cart/add"] input[name="id"]');
      var price = document.querySelector('.product__info-container .price-item--last, .product__info-container .price-item--regular');
      if (price) { var v = parseFloat(price.textContent.replace(/[^0-9.]/g, '')); if (v) box.dataset.price = Math.round(v * 100); }
      paint();
    }, 350); });
  }
  onAll(initPerks);

  /* ---------- Sticky add-to-bag: clean title (no " | GAME | Language" tail) ---------- */
  ready(function () {
    var h = document.querySelector('.hx-ph__title'); if (!h) return;
    document.querySelectorAll('.sticky-atc [class*="sticky-atc-title"]').forEach(function (t) { t.textContent = h.textContent.trim(); });
  });
  /* ---------- Cart page: clean titles, same order cap as the bag ---------- */
  var DROP = ['english','japanese','korean','chinese','simplified chinese','traditional chinese','spanish','pokémon','pokemon','one piece','dragon ball','dragon ball super','magic: the gathering','magic','yu-gi-oh!','yu-gi-oh','riftbound','disney lorcana','lorcana','fusion world','tcg'];
  function cleanTitle(t) {
    var segs = String(t || '').replace(/\s*\((pre-order)\)/ig, '').split(' | ');
    return segs.filter(function (s, i) { return i === 0 || DROP.indexOf(s.trim().toLowerCase()) === -1; }).map(function (s) { return s.trim(); }).join(' · ');
  }
  window.HXCleanTitle = cleanTitle;
  ready(function () {
    if (!document.body.classList.contains('template-cart')) return;
    var tidy = function () {
      document.querySelectorAll('.cart-item__name').forEach(function (a) { if (!a.dataset.hxClean) { a.textContent = cleanTitle(a.textContent.trim()); a.dataset.hxClean = '1'; } });
      document.querySelectorAll('.cart-item').forEach(function (row) { var n = row.querySelector('.cart-item__name'); if (n && /^Free gift/i.test(n.textContent.trim()) && !row.classList.contains('hx-gift-row')) row.classList.add('hx-gift-row'); });
      document.querySelectorAll('.totals__total-value, .totals__subtotal-value').forEach(function (e) { var t = e.textContent.replace(/\s*GBP\s*$/, ''); if (t !== e.textContent) e.textContent = t; });
    };
    var cap = function () {
      var max = (window.HXPerks && window.HXPerks.C && window.HXPerks.C.maxOrder) || 30000;
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
        var over = c.total_price > max;
        document.querySelectorAll('.cart__checkout-button, [name="checkout"]').forEach(function (b) { if (b.disabled !== over) b.disabled = over; });
        document.querySelectorAll('.cart__dynamic-checkout-buttons, .additional-checkout-buttons').forEach(function (d) { d.style.display = over ? 'none' : ''; });
        var box = document.querySelector('.cart__footer .cart__ctas, #main-cart-footer .cart__ctas') || document.querySelector('.cart__ctas'); if (!box) return;
        var msg = document.getElementById('hx-cart-limit');
        if (over) {
          if (!msg) { msg = document.createElement('p'); msg.id = 'hx-cart-limit'; msg.className = 'hx-cart-limit'; msg.setAttribute('role', 'status'); box.parentNode.insertBefore(msg, box); }
          var fmt = function (v) { return new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(v / 100); };
          var txt = 'Orders go up to ' + fmt(max) + '. Remove ' + fmt(c.total_price - max) + ' to continue, or split it into two orders.'; if (msg.textContent !== txt) msg.textContent = txt;
        } else if (msg) msg.remove();
      }).catch(function () {});
    };
    tidy(); cap();
    /* free extras: make sure the gifts match the bag here too (the bag does this when it opens) */
    var R = window.HXPerks, root2 = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var syncGifts = function () { if (R && R.sync) fetch(root2 + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      var before = JSON.stringify(c.items.map(function (i) { return [i.variant_id, i.quantity]; }));
      return Promise.resolve(R.sync(c)).then(function (n) {
        var after = n && n.items ? JSON.stringify(n.items.map(function (i) { return [i.variant_id, i.quantity]; })) : before;
        var k = 'hx_cart_reload', t = 0; try { t = +sessionStorage.getItem(k) || 0; } catch (_) {}
        if (after !== before && Date.now() - t > 8000) { try { sessionStorage.setItem(k, Date.now()); } catch (_) {} location.reload(); }
      });
    }).catch(function () {}); };
    syncGifts();
    var tm = 0; new MutationObserver(function () { clearTimeout(tm); tm = setTimeout(function () { tidy(); cap(); syncGifts(); }, 300); }).observe(document.querySelector('#main-cart-items, cart-items') || document.body, { childList: true, subtree: true });
  });
})();
